export const IconSelect = ({ rotation = 0, color = '#000' }) => (
  <svg
    width='12'
    height='8'
    viewBox='0 0 12 8'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{ transform: `rotate(${rotation}deg)` }}
  >
    <path
      transform={`rotate(${rotation} 6 4)`} // ✅ center of 12x8
      d='M1.22656 1.5L6.22656 6.5L11.2266 1.5'
      stroke={color}
      strokeOpacity='0.8'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
